import cn from 'classnames'
import React, { ComponentProps, ReactElement, ReactNode } from 'react'

import style from './AlertPanel.style'

type AlertPanelProps = {
  className?: string
  icon?: ReactElement
  variant?: 'default' | 'severe' | 'warning' | 'automation'
  children: ReactNode
} & ComponentProps<'div'>

function AlertPanel(props: AlertPanelProps): ReactElement {
  const { className = '', icon, variant = 'default', children, ...rest } = props

  return (
    <div className={cn('AlertPanel', className, variant)} css={style} {...rest}>
      <div className="flex-row gap-3 align-center">
        {icon && <div className="AlertPanel-icon">{icon}</div>}
        {children}
      </div>
    </div>
  )
}

export default AlertPanel
